<app-three-column-template
  [hasCustomMain]="true"
  [pageData]="pageData()"
  [showTags]="false">

  <app-side-navigation [pageData]="pageData()" slot="left-section"></app-side-navigation>
  <app-breadcrumbs [pageData]="pageData()" slot="breadcrumb-section"></app-breadcrumbs>

  <ng-container slot="right-section">
    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'">
    </app-links-section>

    <app-default-portlets
      [hasNews]="false"
      [pageData]="pageData()"></app-default-portlets>

    <app-links-section
      [contentType]="E_CONTENT_TYPE.Resources"
      [links]="pageData()?.relatedResources"
      [relatedId]="pageData()?.id"
      [isDateShown]="false"
      [title]="'Related resources'">
    </app-links-section>
  </ng-container>

  <!-- Content -->
  @if (pageData().showContents) {
    <app-toc></app-toc>
  }
  @if (pageData()?.summary && pageData().type !== E_FOLDER_TYPES.Folder) {
    <app-ck-viewer [htmlDescription]="pageData()?.summary"></app-ck-viewer>
  }
  <app-ck-viewer
    [fullBody]="true"
    [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>
  <app-related-items [noBottomPadding]="true" [pageData]="pageData()"></app-related-items>

  @if (pageData()?.relatedNews?.length) {
    <app-horizontal-divider></app-horizontal-divider>

    <app-latest-news-section
      sectionTitle="Related news"
      [data]="pageData().relatedNews || []"
      [showSeeAllButton]="false">
    </app-latest-news-section>

    <app-see-all
      [contentType]="E_CONTENT_TYPE.News"
      [relatedId]="pageData().id">
    </app-see-all>
  }

</app-three-column-template>
